<div class="bg-black min-h-[280px] flex p-4 gap-4 flex-wrap" style="background-image: linear-gradient(rgba(35,35,35,0.5), rgba(35,35,35,0.5)), url('https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/mainServices/Beneficios.png'); background-size: cover;">
    <div class="gap-4 flex flex-col justify-between flex-1 min-w-0">
    <div class="flex flex-col">
  <span class="typography-title-l" style="color:white;">{{'home.level_up_and_get_more_benefits' | translate}}</span>
  </div>
  <app-button [primary]="true" size="l" class="w-full" (click)="goToBenefits()">
    <span class="pt-4">{{'home.descubre_como_home' | translate }}</span>
  </app-button>

  </div>
</div>
